import { MoreVertIcon } from '@tunasong/icons'
import { RoomMenu, RoomOverlay } from '@tunasong/plugin-video/ui'
import {Button, type ButtonProps, usePresence, Menu} from '@tunasong/ui-lib'
import type { FC } from 'react'
import React, { useCallback, useState } from 'react'
import { useEntityMenuItems } from './entity-menu.hook.js'

import type { Entity, Persisted } from '@tunasong/schemas'
import HelpMenuItem from '../help/help-menu.js'

export interface EntityMenuButtonProps extends ButtonProps {
  className?: string
  entity?: Persisted<Entity>
}

export const EntityMenuButton: FC<EntityMenuButtonProps> = props => {
  const { className, entity, ...buttonProps } = props
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const handleOpen = useCallback((ev: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(ev.currentTarget), [])
  const handleClose = useCallback(() => setAnchorEl(null), [])
  /** @todo should we use presence here? */
  const present = usePresence(entity?.id)

  const { menuItems: entityMenuItems, dialogs: entityDialogs } = useEntityMenuItems({
    entity,
    onClose: handleClose,
    onCloseMenu: handleClose,
  })

  /** Room overlay */
  const [showRoomOverlay, setShowRoomOverlay] = useState(false)
  const toggleRoom = useCallback(() => {
    handleClose()
    setShowRoomOverlay(o => !o)
  }, [handleClose])

  const ref = React.useRef<HTMLButtonElement>(null)
  // const hover = useHover(ref.current)
  // const color = hover ? 'primary' : 'inherit'
  const color = 'primary'

  return (
    <>
      <Button ref={ref} color={color} onClick={handleOpen} aria-label="Menu Dropdown Button" {...buttonProps}>
        <MoreVertIcon />
      </Button>
      <Menu
        className={className}
        anchorEl={anchorEl}
        keepMounted={false}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {...entityMenuItems}

        <RoomMenu open={showRoomOverlay} entityId={entity?.id} onClick={toggleRoom} disabled={present.length === 0} />

        <HelpMenuItem onClose={handleClose} />
      </Menu>

      {showRoomOverlay ? <RoomOverlay open={showRoomOverlay} entityId={entity?.id} /> : null}
      {...entityDialogs}
    </>
  )
}
